import { MutationCache, QueryClient } from "react-query";

import { retryDelayHoldingOutdated, retryUnlessOutdated } from "./apiEpoch";
import { mutationErrorMessage, pushMutationError } from "../state/mutationErrorStore";

// One factory for the app's client and each agent slot's own (AgentSlotProvider), so
// every client shares the same defaults and mutation error path.
export const makeQueryClient = (): QueryClient =>
  new QueryClient({
    // Shared default error path for EVERY mutation (the hard checklist rule
    // "every mutation has user-visible error handling"). Fires for all failures -
    // including fire-and-forget `.mutate()` calls that render nothing themselves -
    // and surfaces a dismissible toast. A mutation that fully owns its own error
    // UI opts out with `meta: { silentError: true }`.
    mutationCache: new MutationCache({
      onError: (error, _vars, _ctx, mutation) => {
        if (mutation.options.meta?.silentError) return;
        pushMutationError(mutationErrorMessage(error));
      },
    }),
    defaultOptions: {
      queries: {
        // Conservative defaults; per-hook overrides set staleTime
        // where freshness matters.
        retry: retryUnlessOutdated(1),
        retryDelay: retryDelayHoldingOutdated,
        refetchOnWindowFocus: false,
      },
    },
  });
